import { Grid } from '@mui/material'
import React from 'react'
import { SecondContainer,Heading,ContentGrid,TextGrid,TextImg,SubHeading,Desc,HeaderDiv,StarImg, } from './style'
import AOS from 'aos'
import { useEffect } from 'react'

const Secondsection = () => {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    },[]);
  return (
    <SecondContainer maxWidth="xxl">
        <Grid container>
            <ContentGrid item xs={12}>
                <HeaderDiv  >
                    <div data-aos="fade-right" data-aos-duration="1000" style={{display:"flex",alignItems: "center"}}>
                        <StarImg  src="./assets/star.png" alt=""/>
                        <Heading>Make anime great again</Heading>
                        <StarImg  src="./assets/star.png" alt=""/>
                    </div>
                </HeaderDiv>
                <div style={{width:"50%"}}  ><img data-aos="fade-right" data-aos-duration="1000" style={{width:"100%",maxWidth:"100%"}} src="./assets/Gears-text.png" alt=""/></div>
                <div style={{width:"50%"}}><TextImg data-aos="fade-up" data-aos-duration="3000" src="./assets/S2-img.png" alt=""/></div>
            </ContentGrid>
        </Grid>
        <Grid container>
            <TextGrid item xs={12} sm={6}  data-aos="fade-right" data-aos-duration="1000">
                    <SubHeading>Hype is real</SubHeading>
                    <div><img style={{width:"80%"}} src="./assets/khaby-img.png" alt=""/></div>
                    <Desc >Khaby.Lame Change His Profile To Gear 5 , Bullish🚀</Desc>
            </TextGrid>
        </Grid>
    </SecondContainer>
  )
}

export default Secondsection
